<div
    [id]="'chartContainer' + variant"
    style="height: 300px; width: 100%; margin-left: auto; margin-right: auto"
></div>
<mat-progress-bar *ngIf="!progressBar.display && !isLoaded" mode="indeterminate"></mat-progress-bar>
<app-progress-bar></app-progress-bar>
